import styled from '@emotion/styled';
import { TimerVariant } from '@/common/countdownTimer/CountdownTimer';

export const TimerContainer = styled.div<{ $variant?: TimerVariant }>`
    display: flex;
    align-items: center;
    width: 100%;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    height: 27px;
    font-family: 'open_sans_semi', sans-serif;

    ${props => props.$variant === 'deals' && `
      @media (max-width: 950px) and (min-width: 710px) {
        flex-direction: column;
        height: auto;
        border: none;
      }
      @media (max-width: 710px) {
        border-radius: 0;
        border: none;
        flex-direction: column;
        height: auto;
        border: none;
      }
  `}
    
    ${props => props.$variant === 'sidekicks' && `
      border-top: 1px solid #CFCECC;
      border-radius: 0px;
      border: none;
      
      @media (max-width: 900px) and (min-width: 651px) {
        flex-direction: column;
        height: auto;
      }
  `}
    
    ${props => props.$variant === 'recipe' && `
      max-width: 362px;
      box-shadow: none;
  `}
}
`;
